<template>
  <ChartWrapper class="ranking-chart" :status="status">
    <div class="root" :class="{smaller:isSmaller}">
      <transition-group name="flip-list" tag="div">
        <div class="item" v-for="item in currentRanking" :key="item.id">
          <div class="bar-and-value">
            <div class="bar" :style="{width:item.width+'%'}"></div>
            <div class="value">{{Math.round(item.value)+'%'}}</div>
          </div>
          <div class="compared-bar" v-if="item.comparedDatum" :style="{width:item.comparedDatum.width+'%'}"></div>
          <div class="label">{{t(item.id)}}</div>
        </div>
      </transition-group>
    </div>
    <div class="month-selector">
      <div class="play-button" @click="playClick" :class="{playing}"></div>
      <div
        class="month-button"
        v-for="month in timeOptions"
        :key="month.value"
        @click="selection = month; playing = false"
        :class="{selected: selection.value===month.value}"
      >{{month.label}}</div>
    </div>
  </ChartWrapper>
</template>

<script>
import ChartWrapper from '@/components/IndicatorCards/parts/charts/ChartWrapper'
let timer
export default {
  name: "RankingChart",
  props: ['data','status','compareData'],
  components: {
    ChartWrapper
  },
  mounted () {
    // this.selection = this.timeOptions[this.timeOptions.length-1]
    this.isSmaller = !this.isMobile && document.body.clientHeight<600
    window.addEventListener('resize',()=>{
      this.isSmaller = !this.isMobile && document.body.clientHeight<600
    })
  },
  // updated () {
  //   this.drawChart()
  // },
  data () {
    return {
      selection: null,
      playing: false,
      isSmaller: false
    }
  },
  computed: {
    currentRanking () {
      if(!this.data) return []
      if(!this.selection) this.selection = this.timeOptions[this.timeOptions.length-1]
      let currentIndex = this.timeOptions.findIndex((m)=>m.value === this.selection.value)
      if(currentIndex === -1) return
      
      let max = this.data.data[0].data.reduce((mmax,dd)=>{
        if(dd.data) mmax = Math.max(mmax,dd.data.reduce((max,d)=>max = Math.max(max,d.value),0))
        return mmax
      },0)

      let currentData = this.data.data[0].data[currentIndex].data || []
      currentData.sort((a,b)=>b.value-a.value)
      // let max = currentData.reduce((max,d)=>max = Math.max(max,d.value),0)
      currentData.forEach((d)=>d.width = 100*d.value/max)
      
      if(this.compareData){
        let currentData2 = this.compareData.data[0].data[currentIndex].data || []
        currentData2.sort((a,b)=>b.value-a.value)
        // let max = currentData.reduce((max,d)=>max = Math.max(max,d.value),0)
        currentData2.forEach((d)=>d.width = 100*d.value/max)
        return currentData.map((d,i)=>({...d,comparedDatum:currentData2[i]}))
      } else {
        return currentData
      }
      
    },
    timeOptions () {
      if(!this.data) return null
      return this.data.data[0].data.map((d)=>{
        return {
          value: d.valueDate,
          label: (new Date(d.valueDate)).toLocaleString('es-ES', {  timeZone: 'Europe/Madrid', month: 'short' }).replace('.',''),
          data: d.data
        }
      })
    }
  },
  watch:{
    data () {
      this.selection = this.timeOptions[this.timeOptions.length-1]
    },
    playing () {
      // if(this.playing) timer = setTimeout(this.playLoop,400)
      if(this.playing) this.playLoop()
      else clearTimeout(timer)
    },
    selection () {
      this.$emit('changeSelection',this.selection)
    }
  },
  methods: {
    playClick () {
      if(!this.playing) {
        if(this.timeOptions.indexOf(this.selection) === this.timeOptions.length-1){
          this.selection = this.timeOptions[0]
        }
      }
      this.playing = !this.playing
    },
    playLoop(){
      let idx = this.timeOptions.indexOf(this.selection)
      let last = this.timeOptions.length-1
      if(idx===last) this.playing = false
      if(this.playing){
        timer = setTimeout(()=>{
          this.selection = this.timeOptions[idx+1]
          this.playLoop()
        },2000)
      } 
    }
  }
}
</script>

<style scoped lang="stylus">
$bar-height = vh(9px)
$compared-bar-height = vh(3px)
.ranking-chart
  background: #fff
  display: flex
  // flex: 1 1 auto
  flex-direction: column
  
  .root
    margin vh(10px) vw(5px) 
    flex: 0 0 auto;
    display: flex
    flex-direction: column
    position relative

    .flip-list-move
      transition: transform 0.4s

    .flip-list-enter,
    .flip-list-leave-to
      // transition: flex .4s;
      opacity: 0
      // flex: 0 0 0px
      // overflow hidden
      // transform: translateX(100%);

    // .flip-list-leave-active
    // position: absolute;
    //.flip-list-leave-active
    .flip-list-leave-active,
      transition all .4s
      position absolute
      bottom 0
    .item
      flex 1 1 auto
      width 100%
      transition: all 1s;
      .bar-and-value
        display flex
        align-items: center;
        // margin: vh(15px) 0;
        .bar
          transition width .4s
          height $bar-height
          background: $bs-blue
          border-radius 2px
        .value
          margin-left 4px
          font-family: 'Lato'
          m-font-size(8,10)
          font-weight bold
          .desktop &
            m-font-size(10,12)
      .compared-bar
        transition width .4s
        height $compared-bar-height
        background: $compare-color
        border-radius 2px
        //margin-top 2px
      .label
        text-transform uppercase
        m-font-size(8,10)
        margin: 0 0 vh(6px) 0;
        font-family 'Lato'
        font-weight bold
        .desktop &
          m-font-size(10,12)
          margin: 0 0 vh(6px) 0;
    &.smaller
      .item
        .label
          margin 0
        .bar-and-value
          .bar
            height vh(10px)
        .compared-bar
          height vh(4px)
  .month-selector
    display: flex
    
    .play-button
      position relative
      flex 0 0 vw(30px)
      
      
      &:not(.playing)
        background #eee
        &:after
          content ''
          position absolute
          left 50%
          top 50%
          transform translate(-50%,-50%)
          width: 0; 
          height: 0; 
          border-top: vw(7px) solid transparent;
          border-bottom: vw(7px) solid transparent;
          
          border-left: vw(12px) solid #666;
      &.playing
        background #ccc
        
        &:before
          content ''
          position absolute
          left 35%
          top 50%
          transform translate(-50%,-50%)
          width: vw(5px)  
          height: 50%; 
          background #666
        &:after
          content ''
          position absolute
          left 58%
          top 50%
          transform translate(-50%,-50%)
          width: vw(5px) 
          height: 50%; 
          background #666


    .month-button
      flex: 1 1 auto
      text-align: center
      font-family 'Lato'
      text-transform uppercase
      background #f8f8f8
      color #666
      m-font-size(10, 10)
      font-weight bold
      padding vw(8px) vw(5px)
      transition background .3s, color .3s
      &.selected
        background: $bs-blue
        color #fff
        border-radius 4px
        
</style>